import { useEffect, useState } from "react";
import axios from "axios";

import Title from "../main/Title";
import DoctorCard from "./DoctorCard";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const DoctorsSection = () => {

  const [doctors, setDoctors] = useState([]);

  const getDoctors = async () => {
    try {

      const res = await axios.get(
        "https://medizenapi.ir/v1/doctor/getDoctors",
        {
          params: {
            page: 1,
            count: 10
          }
        }
      );

      setDoctors(res?.data?.data || []);

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDoctors();
  }, []);

  return (
    <div className="bg-[#e8e8e8] rounded-[20px] py-10 px-3 lg:px-10">

      <div className="flex justify-center">
        <h3 className="text-[20px] font-semibold mb-3 lg:mb-5 text-[#383838]">
          <span>برخی از</span>
          <Title text={" پزشکان "} />
          <span>متخصص ما</span>
        </h3>
      </div>

      <Swiper
        slidesPerView={5}
        breakpoints={{
          0: { slidesPerView: 1, spaceBetween: 10 },
          300: { slidesPerView: 1.5, spaceBetween: 12 },
          600: { slidesPerView: 3, spaceBetween: 12 },
          800: { slidesPerView: 4, spaceBetween: 16 },
          1200: { slidesPerView: 6, spaceBetween: 16 }
        }}
      >

        {doctors.map((doctor) => (

          <SwiperSlide key={doctor.id}>

            <DoctorCard
              id={doctor.id}
              img={'https://bit.medizen.ir/i/' + doctor.thumb}
              name={doctor.name}
              text={doctor.title}
            />

          </SwiperSlide>

        ))}

      </Swiper>

    </div>
  );
};

export default DoctorsSection;
